// Production Key = src_1lg1SLNP84Uk7Ocf2fMZGpo1k10
// Development Key = src_24IRJxuQFWqSPG8zUQIE7zgKAih

!function(co,h,e,s,i,o,n){var d='documentElement';var a='className';h[d][a]+=' preampjs fusejs';
    n.k=e;co._Cohesion=n;co._Preamp={k:s,start:new Date};co._Fuse={k:i};co._Tagular={k:o};
    [e,s,i,o].map(function(x){co[x]=co[x]||function(){(co[x].q=co[x].q||[]).push([].slice.call(arguments))}});
    var b=function(){var u=h[d][a];h[d][a]=u.replace(/ ?preampjs| ?fusejs/g,'')};
    h.addEventListener('DOMContentLoaded',function(){co.setTimeout(b,3e3);
    co._Preamp.docReady=co._Fuse.docReady=!0});var z=h.createElement('script');
    z.async=1;z.src='https://cohesion.lonelyplanet.com/cohesion/cohesion-latest.min.js';
    z.onerror=function(){var ce='error',f='function';for(var o of co[e].q||[])o[0]===ce&&typeof o[1]==f&&o[1]();co[e]=function(n,cb){n===ce&&typeof cb==f&&cb()};b()};
    h.head.appendChild(z);}
    (window,document,'cohesion','preamp','fuse','tagular',{
        cookieDomain: location.hostname.endsWith('lonelyplanet.com') ? 'lonelyplanet.com' : location.hostname,
        domainAllowlist: ["lonelyplanet.com", "shop.lonelyplanet.com", "www.lonelyplanet.com", location.hostname],
        tagular: {
            cookieDomain: location.hostname.endsWith('lonelyplanet.com') ? 'lonelyplanet.com' : location.hostname,
            domainAllowlist: ["lonelyplanet.com", "shop.lonelyplanet.com", "www.lonelyplanet.com", location.hostname],
            writeKey: 'wk_1lg1SLc1gApxa9x71IwXDttlgDh',
            sourceKey: 'src_1lg1SLNP84Uk7Ocf2fMZGpo1k10' 
        }
    })
logger('cohesion loaded')
